import * as bootstrap from "bootstrap";
import "owl.carousel";

import "./search";
import "./carousel";
import "./cart";
import "./comparison";
import cookie from "./cookie";

$(function () {
  // Open menu

  $("#js-menu-open").on("click", function () {
    $("#js-menu").animate({ left: '0px' }, 300, function() {
      $("#js-menu").addClass("js-opened");
    });
  });

  // Close menu

  $("#js-menu-close").on("click", function () {
    const left = window.matchMedia("(min-width: 992px)").matches ? '-70vw' : '-100vw';
    $("#js-menu").animate({ left }, 300, function() {
      $("#js-menu").removeClass("js-opened");
      $("#js-menu-search").val('');
      $(this).find(".df-search__results__title").empty();
      $(this).find(".df-search__results__inner").empty();
      $(this).find(".df-search__results__empty").addClass("d-none");
      $(this).find('.df-search__results__loader').removeClass("active");
      $(this).find(".df-search__results").addClass("d-none");
    });
  });

  // Open catalog

  $("#js-catalog-open").on("click", function () {
    const top = $('.df-header__nav').offset().top + $('.df-header__nav').outerHeight() - 1;
    const height = $('#js-catalog').find('.container').outerHeight() + 70;
    $("#js-catalog").css('top', top + 'px');
    $("#js-catalog").animate({ height, }, 300, function() {
      $("#js-catalog").addClass("js-opened");
    });
  });

  // Close catalog

  $("#js-catalog-close").on("click", function () {
    $("#js-catalog").animate({ height: 0 }, 300, function() {
      $("#js-catalog").removeClass("js-opened");
    });
  });

  // Collapse icon rotation

  $(".js-collapse").each(function () {
    const icon = $(this).find(".js-collapse-icon");

    if (icon) {
      $(this).on("click", function () {
        icon.toggleClass("df-rotate--90");
      });
    }
  });

  // Toggle catalog collapse btn text

  $("#js-collapse-menu-catalog").on("click", function () {
    const text = $(this).hasClass("collapsed")
      ? $(this).data('show-text')
      : $(this).data('hide-text');
    $(this).find("span").text(text);
  });

  // Anchor links

  $(".js-anchor-link").on("click", function (e) {
    e.preventDefault();

    const target = $(this).attr("href");
    if (target && $(target).offset()) {
      const offset = window.matchMedia("(min-width: 768px)").matches ? 80 : 100;
      $("html, body").animate(
        { scrollTop: $(target).offset().top - offset },
        600
      );
    }
  });

  $(window).on("click", function (e) {
    if ($(e.target).parents("#js-menu").length == 0 && $("#js-menu").hasClass("js-opened")) {
      $("#js-menu-close").trigger("click");
    }

    if ($(e.target).parents("#js-catalog").length == 0 && $("#js-catalog").hasClass("js-opened")) {
      $("#js-catalog-close").trigger("click");
    }

    if ($(e.target).parents("#js-search").length == 0 && $("#js-search").hasClass("js-opened")) {
      $("#js-search-close").trigger("click");
    }
  });

  // Search in menu

  // $("#js-menu-search").on("keyup", function (e) {
  //   let searchStr = $(this).val().toLowerCase();
  //   let searchValues = searchStr.split(" ").filter((elem) => elem !== "");
  // });

  // Tooltip initialize

  const tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  );
  const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });

  // Toast initialize

  // const toastElList = [].slice.call(document.querySelectorAll(".toast"));
  // const toastList = toastElList.map(function (toastEl) {
  //   return new bootstrap.Toast(toastEl, option);
  // });

  // Number masks

  // function doFormat(x, format, mask) {
  //   var strippedValue = x.replace(/[^0-9]/g, "");
  //   var chars = strippedValue.split("");
  //   var count = 2;
  //   var pattern = format.split("+7")[1];

  //   var formatted = "";
  //   for (var i = 0; i < pattern.length; i++) {
  //     const c = pattern[i];
  //     if (chars[count]) {
  //       if (/\*/.test(c)) {
  //         formatted += chars[count];
  //         count++;
  //       } else {
  //         formatted += c;
  //       }
  //     } else if (mask) {
  //       if (mask.split("")[i]) formatted += mask.split("")[i];
  //     }
  //   }
  //   return formatted;
  // }

  // document.querySelectorAll("[data-mask]").forEach(function (e) {
  //   function format(elem) {
  //     const val = doFormat(elem.value, elem.getAttribute("data-format"));
  //     elem.value = doFormat(
  //       elem.value,
  //       elem.getAttribute("data-format"),
  //       elem.getAttribute("data-mask")
  //     );

  //     if (elem.createTextRange) {
  //       var range = elem.createTextRange();
  //       range.move("character", val.length);
  //       range.select();
  //     } else if (elem.selectionStart) {
  //       elem.focus();
  //       elem.setSelectionRange(val.length, val.length);
  //     }
  //   }
  //   // e.addEventListener("keyup", function () {
  //   //   format(e);
  //   // });
  //   // e.addEventListener("keydown", function () {
  //   //   format(e);
  //   // });
  //   e.addEventListener("input", function () {
  //     format(e);
  //   });
  //   format(e);
  // });

  // Help modal form

  const helpModal = new bootstrap.Modal($("#js-helpModal"));
  const successToastEl = $("#js-successToast");
  const successToast = new bootstrap.Toast(successToastEl);
  const errorToastEl = $("#js-errorToast");
  const errorToast = new bootstrap.Toast(errorToastEl);

  $("#js-help-form").on("submit", function (e) {
    e.preventDefault();

    const form = $(this);
    const url = form.attr("action");

    $.ajax({
      type: "POST",
      url: url,
      data: form.serialize(),
      success: function (data) {
        form.find("textarea#message").val("");
        helpModal.hide();
        successToastEl.find(".toast-body").html(data.message || "Ваше сообщение отправлено");
        successToast.show();
      },
      error: function (xhr) {
        console.error(xhr);
        try {
          const errorResp = JSON.parse(xhr.responseText);
          // let errorStr = "";
          if (errorResp.errors) {
            // Object.values(errorResp.errors).forEach((messages) => {
            //   messages.forEach((msg) => errorStr += msg + '\n');
            // });
            // form.addClass("was-validated");
            Object.keys(errorResp.errors).forEach((key) => {
              let errorMsg = "";
              errorResp.errors[key].forEach((msg) => errorMsg += msg + "\n");
              form.find("#" + key).addClass("is-invalid");
              form.find("#" + key).siblings(".invalid-feedback").html(errorMsg || "Неверное занчение");
            });
          }
          // errorToastEl.find(".toast-body").html(errorResp.message || "Возникла ошибка при отправке сообщения. Повторите попытку позже");
          // errorToast.show();
        } catch (e) {
          errorToastEl.find(".toast-body").html("Возникла ошибка при отправке сообщения. Повторите попытку позже");
          errorToast.show();
        }
      },
    });
  });

  const cookieConsentEl = document.getElementById("js-cookie-consent");
    const cookieConsentBtnCloseEl = document.getElementById("js-cookie-consent-btn-close");
    const cookieConsentAccepted = cookie.getCookie("defender_cookie-consent");
    if (cookieConsentEl && !cookieConsentAccepted) {
        cookieConsentEl.classList.remove("d-none");
    }

    if (cookieConsentBtnCloseEl && cookieConsentEl) {
        cookieConsentBtnCloseEl.addEventListener("click", function () {
            cookie.setCookie("defender_cookie-consent", true, { secure: true, 'max-age': 3600 * 24 * 30 * 365 });
            cookieConsentEl.classList.add("d-none");
        });
    }
});
